module.exports = __webpack_public_path__ + "2d5b8a318ee4a4dd15b60c0bade37c97.png";